var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "galleryComponent",
      staticClass: "gallery-wrapper contained",
      class: { "overlay-active": _vm.overLayActive },
    },
    [
      _vm.options.ShowFilteringFacets
        ? _c(
            "div",
            { staticClass: "gallery-filters" },
            [
              _c("div", { staticClass: "gallery-filter-heading" }, [
                _vm._v(_vm._s(_vm.options.CategoryHeadingLabel) + ":"),
              ]),
              _vm._v(" "),
              _c("accessible-tabs", [
                _c(
                  "ul",
                  {
                    attrs: {
                      role: "list",
                      "aria-label": _vm.options.CategoryHeadingLabel,
                    },
                  },
                  [
                    _c(
                      "li",
                      {
                        class: { "is-active": !_vm.currentCategory },
                        attrs: {
                          role: "listitem",
                          "data-name": _vm.options.CategoryAllLabel,
                          "aria-selected": !_vm.currentCategory,
                          tabindex: !_vm.currentCategory ? "0" : "-1",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.$router.push({ query: {} })
                          },
                          keypress: [
                            function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              $event.preventDefault()
                              return _vm.$router.push({ query: {} })
                            },
                            function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "space",
                                  32,
                                  $event.key,
                                  [" ", "Spacebar"]
                                )
                              ) {
                                return null
                              }
                              $event.preventDefault()
                              return _vm.$router.push({ query: {} })
                            },
                          ],
                        },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.options.CategoryAllLabel) +
                            "\n        "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _vm._l(_vm.categories, function (category) {
                      return _c(
                        "li",
                        {
                          key: category.Id,
                          class: {
                            "is-active":
                              _vm.currentCategory === category.Description,
                          },
                          attrs: {
                            id: category.Id,
                            role: "tab",
                            "data-name": category.Description,
                            "aria-selected":
                              _vm.currentCategory === category.Description,
                            tabindex:
                              _vm.currentCategory === category.Description
                                ? "0"
                                : "-1",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.$router.push({
                                query: { category: category.Description },
                              })
                            },
                            keypress: [
                              function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                $event.preventDefault()
                                return _vm.$router.push({
                                  query: { category: category.Description },
                                })
                              },
                              function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "space",
                                    32,
                                    $event.key,
                                    [" ", "Spacebar"]
                                  )
                                ) {
                                  return null
                                }
                                $event.preventDefault()
                                return _vm.$router.push({
                                  query: { category: category.Description },
                                })
                              },
                            ],
                          },
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(category.Description) +
                              "\n        "
                          ),
                        ]
                      )
                    }),
                  ],
                  2
                ),
              ]),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "gallery-filter-view" }, [
        _c("div", { staticClass: "gallery-filter-view-label" }, [
          _vm._v(_vm._s(_vm.options.MobileViewLabel)),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "gallery-filter-view-icons" }, [
          _c("button", {
            staticClass: "stack-view",
            class: { active: !_vm.IsMobileGridView },
            attrs: { "aria-label": "", disabled: !_vm.IsMobileGridView },
            on: {
              click: function ($event) {
                return _vm.toggleGridView("stack")
              },
              keypress: [
                function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  $event.preventDefault()
                  return _vm.toggleGridView("stack")
                },
                function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "space", 32, $event.key, [
                      " ",
                      "Spacebar",
                    ])
                  ) {
                    return null
                  }
                  $event.preventDefault()
                  return _vm.toggleGridView("stack")
                },
              ],
            },
          }),
          _vm._v(" "),
          _c("button", {
            staticClass: "grid-view",
            class: { active: _vm.IsMobileGridView },
            attrs: { "aria-label": "", disabled: _vm.IsMobileGridView },
            on: {
              click: function ($event) {
                return _vm.toggleGridView("grid")
              },
              keypress: [
                function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  $event.preventDefault()
                  return _vm.toggleGridView("stack")
                },
                function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "space", 32, $event.key, [
                      " ",
                      "Spacebar",
                    ])
                  ) {
                    return null
                  }
                  $event.preventDefault()
                  return _vm.toggleGridView("stack")
                },
              ],
            },
          }),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "transition-group",
        {
          ref: "galleryGrid",
          staticClass: "gallery-grid",
          class: {
            stack: !_vm.IsMobileGridView && _vm.isMobile,
            "carousel-opened": _vm.overLayActive,
          },
          attrs: { tag: "div", name: "gallery-grid" },
        },
        _vm._l(_vm.items, function (item, index) {
          return _c(
            "div",
            {
              key: item.Id + "gallery",
              staticClass: "tile",
              class: {
                video: item.IsVideo === true,
                "featured-1": item.Enhance === true && index === 0,
                "featured-2": item.Enhance === true && index === 1,
                enhanced: item.Enhance === true && index > 1,
              },
              attrs: { tabindex: "0", id: item.Id },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.setCurrentImage(index)
                },
                keypress: [
                  function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    $event.preventDefault()
                    return _vm.setCurrentImage(index)
                  },
                  function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "space", 32, $event.key, [
                        " ",
                        "Spacebar",
                      ])
                    ) {
                      return null
                    }
                    $event.preventDefault()
                    return _vm.setCurrentImage(index)
                  },
                ],
              },
            },
            [
              _c(
                "div",
                {
                  staticClass: "content",
                  class: [
                    { "grid-view": _vm.IsMobileGridView && _vm.isMobile },
                  ],
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "tile-media",
                      attrs: { "data-id": item.Id, id: "position-" + index },
                    },
                    [
                      (item.IsVideo && _vm.IsMobileGridView) ||
                      (item.IsVideo && !_vm.isMobile)
                        ? _c("div", { staticClass: "gallery-play-icon" }, [
                            _c("span", [_vm._v(_vm._s(_vm.options.Play))]),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "picture",
                        {
                          directives: [
                            {
                              name: "lazyload",
                              rawName: "v-lazyload",
                              value: {
                                src: item.IsVideo
                                  ? _vm.renderGridMedia(
                                      item.DesktopVideoPosterImage
                                    )
                                  : item.ImageSrc,
                                set: [{ width: "800", breakpoint: "xs" }],
                                fit: "crop",
                                align: "center",
                                ratio: item.ImageRatio,
                                updateCallback: _vm.imageLoaded,
                              },
                              expression:
                                "{\n              src: item.IsVideo ? renderGridMedia(item.DesktopVideoPosterImage) : item.ImageSrc,\n              set: [{ width: '800', breakpoint: 'xs' }],\n              fit: 'crop',\n              align: 'center',\n              ratio:  item.ImageRatio,\n              updateCallback: imageLoaded\n            }",
                            },
                          ],
                          staticClass: "image-wrapper",
                          class: [
                            { stack: !_vm.IsMobileGridView && _vm.isMobile },
                            { video: item.IsVideo },
                          ],
                        },
                        [
                          _c("img", {
                            staticClass: "image",
                            attrs: {
                              src: "data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==",
                              alt: item.Title,
                            },
                          }),
                        ]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  item.IsVideo && !_vm.IsMobileGridView && _vm.isMobile
                    ? _c("video-player", {
                        class: { stack: !_vm.IsMobileGridView && _vm.isMobile },
                        attrs: {
                          "desktop-video": item.DesktopVideo,
                          "desktop-video-poster-image":
                            item.DesktopVideoPosterImage !== ""
                              ? item.DesktopVideoPosterImage
                              : _vm.options.GalleryMissingImage,
                          "disabled-toggle": !_vm.IsMobileGridView
                            ? false
                            : true,
                          "pause-control": _vm.currentPlaying !== item.Id,
                          dictionary: _vm.videoPlayerDictionary,
                          "alt-text": item.Title,
                          "pause-on-hide": "",
                        },
                        on: { mounted: _vm.imageLoaded },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.IsMobileGridView && _vm.isMobile,
                          expression: "!IsMobileGridView && isMobile",
                        },
                      ],
                      staticClass: "tile-grid-content",
                    },
                    [
                      _c("div", { staticClass: "gallery-item-title" }, [
                        _vm._v(_vm._s(item.Title)),
                      ]),
                      _vm._v(" "),
                      item.ShortDescription.length
                        ? _c(
                            "div",
                            { staticClass: "gallery-item-description" },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(item.ShortDescription) +
                                  "\n          "
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      item.CtaUrl.length
                        ? _c("div", { staticClass: "gallery-item-cta" }, [
                            _c("a", {
                              attrs: {
                                href: item.CtaUrl,
                                target: item.CtaTarget,
                              },
                              domProps: {
                                innerHTML: _vm._s(
                                  item.CtaText != ""
                                    ? item.CtaText
                                    : _vm.options.LearnMore
                                ),
                              },
                              on: {
                                click: function ($event) {
                                  $event.preventDefault()
                                  $event.stopPropagation()
                                  return _vm.handleAnchorClick(item)
                                },
                              },
                            }),
                          ])
                        : _vm._e(),
                    ]
                  ),
                ],
                1
              ),
            ]
          )
        }),
        0
      ),
      _vm._v(" "),
      !_vm.allLoaded
        ? _c("div", { staticClass: "gallery-load-more show" }, [
            _c(
              "button",
              {
                on: {
                  click: function ($event) {
                    return _vm.loadMore()
                  },
                  keypress: [
                    function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      ) {
                        return null
                      }
                      $event.preventDefault()
                      return _vm.loadMore()
                    },
                    function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "space", 32, $event.key, [
                          " ",
                          "Spacebar",
                        ])
                      ) {
                        return null
                      }
                      $event.preventDefault()
                      return _vm.loadMore()
                    },
                  ],
                },
              },
              [_vm._v(_vm._s(_vm.options.LoadMore))]
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.overLayActive
        ? _c(
            "div",
            {
              staticClass: "gallery-overlay",
              class: { show: _vm.overLayActive },
            },
            [
              _c("div", { staticClass: "gallery-overlay-background" }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "gallery-overlay-content contained" },
                [
                  _c("gallery-carousel", {
                    attrs: { items: _vm.filteredItems, options: _vm.options },
                    on: {
                      close: _vm.unSetCurrentImage,
                      scroll: _vm.scrollToImage,
                    },
                  }),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }